module.exports = __webpack_public_path__ + "media/assets/icons/star-b994164c171ff362fbcfed11276c2af5.svg";